export type HttpMethod = "get" | "post" | "delete" | null;

export interface Error {
    baseUrl: string;
    url: string;
    method: HttpMethod;
    requestData: string;
    status: number;
    statusText: string;
    message: string;
    stack: string;
}
// APIエラー戻り値定義
export class ErrorResponse {
    response!: Response;
    stack!: string;
}

export interface Response {
    status: number;
}
